export const fr = {
  table: {
    emptyState: {
      filtersAppliedHint: 'Au moins un filtre est appliqué.',
    },
  }
}